module.exports = __webpack_public_path__ + "images/emoji/information_desk_person.24217a68901ef53fb9fe.png";